import { useToast, Toast, ToastDescription } from "@/components/ui/toast";

import React from 'react'
// ---

import { useSelector, useDispatch } from "react-redux";
import { deleteModal, updateModal } from '../../../../stores/mainSlice';
import { requestModal } from '../../../../stores/mainSlice';
import { backendRequest } from "../../../../stores/thunks";
import { saveImageAsync } from "../../../../stores/thunks";

import { ContactConfirm } from './ContactConfirm';
import { ContactRequest } from './ContactRequest';
import { ContactLinkedPreference } from './ContactLinkedPreference';
import { ContactPreference } from './ContactPreference';

import { ChannelConfirm } from './ChannelConfirm';
import { ChannelLinkedPreference } from './ChannelLinkedPreference';
import { ChannelPreference } from './ChannelPreference';


export const ModalMaster = () => {
  const dispatch = useDispatch();
  const staged_modals = useSelector((state) => state.temp?.modal);
  const visible_modals = {};

  for (const type in staged_modals) {
    visible_modals[type] = {
      type,

      opened: staged_modals[type].opened,
      option: staged_modals[type].option,

      onUpdate: (option) => {
        dispatch(updateModal({ type, option }));
      },
      onClose: () => {
        dispatch(deleteModal({ type }));
      },
      onRequest: (key, endpoint, payload, method) => {
        return dispatch(backendRequest(key, endpoint, payload, method ?? 'POST', false));
      },
      onUploadImageAsyncRequest: (key, endpoint, payload) => {
        return dispatch(saveImageAsync(key, endpoint, payload));
      }
    }
  }

  return (
    <>
      {/* Toast */}
      <Task_Toast isVisible={'toast' in visible_modals} {...visible_modals['toast']} />

      {/* Manage Contacts */}
      <ContactRequest isVisible={'contact:create' in visible_modals} {...visible_modals['contact:create']} />
      <ContactPreference isVisible={'contact:update' in visible_modals} {...visible_modals['contact:update']} />
      <ContactLinkedPreference isVisible={'contact:update-workflows' in visible_modals} {...visible_modals['contact:update-workflows']} />
      <ContactLinkedPreference isVisible={'contact:update-channels' in visible_modals} {...visible_modals['contact:update-channels']} />
      <Task_Without_Modal isVisible={'contact:accept-request' in visible_modals} {...visible_modals['contact:accept-request']} />
      <Task_Without_Modal isVisible={'contact:decline-request' in visible_modals} {...visible_modals['contact:decline-request']} />
      <Task_Without_Modal isVisible={'contact:delete-request' in visible_modals} {...visible_modals['contact:delete-request']} />
      <ContactConfirm isVisible={'contact:remove' in visible_modals} {...visible_modals['contact:remove']} />

      {/* Manage Broadcast Channels */}
      <ChannelPreference isVisible={'channel:create' in visible_modals} {...visible_modals['channel:create']} />
      <ChannelPreference isVisible={'channel:update' in visible_modals} {...visible_modals['channel:update']} />
      <ChannelLinkedPreference isVisible={'channel:update-workflows' in visible_modals} {...visible_modals['channel:update-workflows']} />
      <ChannelLinkedPreference isVisible={'channel:update-members' in visible_modals} {...visible_modals['channel:update-members']} />
      <ChannelConfirm isVisible={'channel:remove' in visible_modals} {...visible_modals['channel:remove']} />

      {/* + add component for new modals */}
    </>
  )
}

const Task_Without_Modal = (modal) => {
  const dispatch = useDispatch();

  if (modal.option?.request?.isAcknowledged) {
    if ('onClose' in modal) modal.onClose();
    return (<></>);
  }

  if (!modal.isVisible || modal.option?.request?.isWaiting) return (<></>);

  modal.onUpdate({ request: { isWaiting: true, isAcknowledged: false, issues: null } });

  // ?
  const whenAcknowledge = (callback) => {
    return (data) => {
      // ---
      console.debug('[Modal]', 'onRequest.then', !!data.result, data?.result)
      // ---

      modal.onUpdate({ request: { isWaiting: true, isAcknowledged: true, issues: null } });
      callback(data);
    }
  }

  // ?
  switch (modal.type) {
    case 'contact:accept-request':
      modal.onRequest('ACCEPT_REQUEST_INLINE', '/contact', {
        userId: modal.option?.fromUser?.id,
        requestId: modal.option?.request?.id,
      }, 'POST').then(whenAcknowledge((data) => {
        dispatch(requestModal({
          type: 'toast',
          option: {
            text: !data.result ? 'contact.declineFailed' : 'contact.declineSuccessful'
          }
        }));
      }));
      break;

    case 'contact:decline-request':
      modal.onRequest('DECLINE_REQUEST_INLINE', '/contact/request', {
        userId: modal.option?.fromUser?.id,
        requestId: modal.option?.request?.id,
      }, 'PUT').then(whenAcknowledge((data) => {
        dispatch(requestModal({
          type: 'toast',
          option: {
            text: !data.result ? 'contact.declineFailed' : 'contact.declineSuccessful'
          }
        }));
      }));
      break;

    case 'contact:delete-request':
      modal.onRequest('DELETE_REQUEST_INLINE', '/contact/request', {
        userId: modal.option?.toUser?.id,
        requestId: modal.option?.request?.id,
      }, 'DELETE').then(whenAcknowledge((data) => {
        dispatch(requestModal({
          type: 'toast',
          option: {
            text: !data.result ? 'contact.deleteFailed' : 'contact.deleteSuccessful'
          }
        }));
      }));
      break;
  }


  return (<></>)
}

const Task_Toast = (modal) => {
  if (!modal.isVisible) {
    return (<></>);
  }

  modal.onClose();

  const toast = useToast();
  const toast_id = `${Date.now()}-${Math.random()}`;

  toast.show({
    id: toast_id,
    placement: "bottom",
    duration: 3000,
    render: ({ id }) => {
      const uniqueToastId = "toast-" + id;

      return (
        <Toast
          duration={5000}
          nativeID={uniqueToastId}
          action="muted"
          variant="solid"
          containerStyle={{
            marginBottom: '2xl'
          }}
        >
          {/* <ToastTitle>Hello!</ToastTitle> */}
          <ToastDescription>${modal.option?.text}</ToastDescription>
        </Toast>
      );
    },
  });

  return (<></>);
}